import React, { useEffect, useState } from 'react';
import { getAvailablePsikolog } from '../api/appointment';

function Step2Tnc({ formData, handleInputChange, prevStep, nextStep, setPsikologData }) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const allChecked = formData.agreeTnc1 && formData.agreeTnc2;
    if (formData.agreeAll !== allChecked) {
      handleInputChange({ 
        target: { 
          name: 'agreeAll', 
          value: allChecked, 
          type: 'checkbox', 
          checked: allChecked 
        } 
      });
    }
  }, [formData.agreeTnc1, formData.agreeTnc2]);

  const handleAgreeAll = (e) => {
    const checked = e.target.checked;
    handleInputChange(e);
    
    handleInputChange({ 
      target: { 
        name: 'agreeTnc1', 
        value: checked, 
        type: 'checkbox', 
        checked 
      } 
    });
    
    handleInputChange({ 
      target: { 
        name: 'agreeTnc2', 
        value: checked, 
        type: 'checkbox', 
        checked 
      } 
    });
  };

  const handleNext = async () => {
    setLoading(true);
    setError(null);

    try {
       const params = new URLSearchParams(window.location.search);
    const userRole = params.get("user"); // Hasilnya: "admin" atau null
      const res = await getAvailablePsikolog({
        date: formData.date,     // asumsi sudah ada di formData
        bahasa: formData.bahasa || '',
        name: formData.name || '',
        user: userRole,
      });

      if (res.status === true) {
        // simpan data psikolog ke parent (Step 3)
       setPsikologData(res.data.psikolog_list || []);

        nextStep();
      } else {
        setError(res.msg || 'Gagal mengambil data psikolog');
      }
    } catch (err) {
      console.error(err);
      setError('Terjadi kesalahan saat mengambil data psikolog');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="step-content active">
       {loading && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          backgroundColor: 'rgba(255, 255, 255, 0.7)',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 9999,
          backdropFilter: 'blur(2px)'
        }}>
          <div className="spinner-border text-primary" role="status" style={{ width: '3rem', height: '3rem' }}>
            <span className="visually-hidden">Loading...</span>
          </div>
          {/* <p className="mt-3 fw-bold text-primary">Mohon tunggu sebentar...</p> */}
        </div>
      )}
      <h5>Syarat & Ketentuan</h5>

      {/* ====== SELURUH JSX DI BAWAH INI TIDAK DIUBAH ====== */}

      <div className="border p-3 mb-3 shadow-sm rounded">
        <h6 className="fw-bold">
          Syarat dan Ketentuan Booking Jadwal Konsultasi Tes Bakat Indonesia (1)
        </h6>
        <div className="mb-3">
          <ul className="list-unstyled ps-0 mb-0" style={{ textAlign: 'justify' }}>
            <li className="mb-2">
                    1. Klien memiliki batas waktu maksimal 3 bulan sejak
                    pendaftaran paket untuk melakukan booking dan menghadiri
                    sesi konseling.
                  </li>
                  <li className="mb-2">
                    2. Sesi konseling hanya tersedia secara online menggunakan
                    fasilitas video audio. Klien diharapkan memastikan device
                    dan koneksi internet yang dimiliki berjalan dengan baik dan
                    menggunakan ruangan yang privat (bukan tempat umum) agar
                    bisa mengikuti sesi konseling secara maksimal. Adapun
                    ketidaknyamanan atau gangguan pada proses konseling
                    dikarenakan klien mengalami gangguan device, koneksi, dan
                    pemilihan ruangan konseling yang berisik, atau sambil
                    melakukan aktivitas lain bersamaan saat sedang proses
                    konseling akan menjadi tanggungan klien.
                  </li>
                  <li className="mb-2">
                    3. Durasi waktu penjelasan hasil adalah sesuai paket yang
                    diambil, dan bila klien terlambat dari waktu appointment
                    (maksimal 15 menit) maka klien dapat berkonsultasi selama
                    sisa waktu yang dimiliki.
                  </li>
                  <li className="mb-2">
                    4. Klien berhak mengganti pilihan jadwal konseling yang
                    sudah dipilih selambatnya 2 hari sebelumnya (dengan batas
                    waktu jam 12.00 WIB).
                  </li>
                  <li className="mb-2">
                    5. Jadwal konseling yang sudah terpilih akan dilkunci oleh
                    sistem di H-2 jam 12.00 WIB dan tidak bisa diubah.
                  </li>
                  <li className="mb-2">
                    6. Apabila klien tidak hadir atau membatalkan appointment
                    konseling secara setelah batas waktu H-2 jam 12.00 WIB, maka
                    sesi konseling akan dianggap hangus dan klien dapat meminta
                    akses pemilihan jadwal konseling baru dengan menghubungi
                    Client Care. Adapun sesi baru ini akan dikenai biaya sesi
                    konseling sesuai ketentuan Tes Bakat Indonesia.
                  </li>
                  <li className="mb-2">
                    7. Sesi konseling online ini akan direkam oleh psikolog
                    untuk evaluasi internal. Klien tidak diperkenankan untuk
                    merekam sendiri sesi penjelasan hasil yang berlangsung dan
                    juga tidak mendapatkan rekaman sesi penjelasan hasil
                    sehingga diharapkan untuk dapat mengikuti sesi penjelasan
                    hasil secara sungguh-sungguh.
                  </li>
                  <li className="mb-0">
                    8. Tes Bakat Indonesia berhak untuk menunda dan mengatur
                    ulang layanan konseling jika terjadi keadaan darurat atau
                    forcemajor seperti bencana alam, kerusuhan, dan lain-lain.
                  </li>
            </ul>
        </div>

        <div className="form-check">
          <strong>
            <input
              className="form-check-input"
              type="checkbox"
              id="agreeTnc1"
              name="agreeTnc1"
              checked={formData.agreeTnc1}
              onChange={handleInputChange}
            />
            <label className="form-check-label" htmlFor="agreeTnc1">
              Saya bersedia mengikuti semua syarat dan ketentuan di atas tanpa terkecuali.
            </label>
          </strong>
        </div>
      </div>

      <div className="border p-3 mb-3 shadow-sm rounded">
        <h6 className="fw-bold">
          Syarat dan Ketentuan Booking Jadwal Konsultasi Tes Bakat Indonesia (2)
        </h6>

         <div className="mb-3">
                <ul className="list-unstyled ps-0 mb-0" style={{ textAlign: 'justify' }}>
                  <li className="mb-2">
                    1. Jadwal atau sesi konseling yang bisa Anda pilih sudah
                    disesuaikan oleh sistem berdasarkan waktu e-report dari
                    paket asesmen Anda tersedia.
                  </li>
                  <li className="mb-0">
                    2. Silahkan memilih berdasarkan ketersediaan jadwal yang
                    tampil dan preferensi Anda.
                  </li>
                </ul>
              </div>

        <div className="form-check">
          <strong>
            <input
              className="form-check-input"
              type="checkbox"
              id="agreeTnc2"
              name="agreeTnc2"
              checked={formData.agreeTnc2}
              onChange={handleInputChange}
            />
            <label className="form-check-label" htmlFor="agreeTnc2">
              Saya bersedia mengikuti semua syarat dan ketentuan di atas tanpa terkecuali.
            </label>
          </strong>
        </div>
      </div>

      <div className="form-check mb-3">
        <input
          className="form-check-input"
          type="checkbox"
          id="agreeAll"
          name="agreeAll"
          checked={formData.agreeAll}
          onChange={handleAgreeAll}
        />
        <label className="form-check-label" htmlFor="agreeAll">
          <strong>Saya telah membaca dan menyetujui semua syarat dan ketentuan di atas</strong>
        </label>
      </div>

      {error && (
        <div className="alert alert-danger">{error}</div>
      )}

      <br />

      <div className="d-flex justify-content-between mt-4">
        <button
          type="button"
          className="btn btn-secondary btn-footer"
          onClick={prevStep}
        >
          <i className="bi bi-arrow-left-short"></i> Kembali
        </button>

        <button
          type="button"
          className="btn btn-primary btn-footer"
          id="btnAgree"
          disabled={!formData.agreeAll || loading}
          onClick={handleNext}
        >
          {loading ? 'Memuat...' : (
            <>
              Lanjut <i className="bi bi-arrow-right-short"></i>
            </>
          )}
        </button>
      </div>
    </div>
  );
}

export default Step2Tnc;
